import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import moment from 'moment';
import { closeModal } from '../../../action/modalbehaviour.js';


const AddLeave = ({list}) => {
    const [teamLead, setTeamLead] = useState([]);
    const [days, setDays] = useState(0);
    const [time, setTime] = useState('');

    const schema = Yup.object().shape({
        leave_type: Yup.string().required('leave type is a required field'),
        from_date: Yup.date().when('leave_type', {
            is: value => value !== 'Medical (Medical Certificate Required)',
            then: () => Yup.date().nullable().typeError('from date is a required field')
                    .required('from date is a required field')
                    .min(moment().subtract(1, 'day').toDate(), 'from date cannot be in the past'),
            otherwise: () => Yup.date().nullable().typeError('from date is a required field')
                    .required('from date is a required field')
                    .max(new Date(), 'from date cannot be in future')
        }),
        to_date: Yup.date().when('leave_type', {
            is: value => value !== 'Medical (Medical Certificate Required)',
            then: () => Yup.date().nullable().typeError('to date is a required field')
                    .required('to date is a required field')
                    .min(moment().subtract(1, 'day').toDate(), 'to date cannot be in the past'),
            otherwise: () => Yup.date().nullable().typeError('from date is a required field')
                    .required('to date is a required field')
                    .max(new Date(), 'to date cannot be in future')
        }),
        from_time: Yup.string().required('from time is a required field'),
        to_time: Yup.string().required('to time is a required field'),
        requested_to: Yup.string().required('requested to is a required field'),
        reason: Yup.string().required()
    });
    
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const formData = {
            ...data,
            from_date: data.from_date.toLocaleDateString('en-CA'),
            to_date: data.to_date.toLocaleDateString('en-CA')
        };

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/leaves`, formData)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                reset();
                closeModal("add_leave");
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    const fetchTeamLead = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=teamleads`)
            .then(response => {
                setTeamLead(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching teamleads', error);
                setTeamLead([]);
            });
    };

    useEffect(() => {
        fetchTeamLead();

        const modalElement = document.getElementById('add_leave');
        const handleClose = () => reset();

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [reset]);


    const checkNumberOfDays = (fromDate, toDate) => {        
        const oneDay = 24 * 60 * 60 * 1000;
        const diffInTime = Math.abs(moment(fromDate) - moment(toDate));
        const diffInDays = Math.round(diffInTime / oneDay);
        
        setDays(diffInDays+1);
    }

    const calculateTimeDiff = (fromTime, toTime) => {
        const from = moment(fromTime, "HH:mm");
        const to = moment(toTime, "HH:mm");
    
        const diff = moment.duration(to.diff(from));
    
        const hours = Math.floor(diff.asHours());   // Get total hours
        const minutes = diff.minutes();             // Get remaining minutes
    
        const formattedDiff = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
   
        setTime(formattedDiff);
    };
    
    
    return (
        <div id="add_leave" className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Leave</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Leave Type <span className="text-danger">*</span></label>
                                        <div className="radio">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td width={"40%"}>
                                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                                <input type="radio" value="Regular" {...register('leave_type')} /> Regular
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                                <input type="radio" value="Medical (Medical Certificate Required)" {...register('leave_type')} /> Medical (Medical Certificate Required)
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                                <input type="radio" value="Regular Half Day Leave" {...register('leave_type')} /> Regular Half Day Leave
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                                <input type="radio" value="Medical Half Day Leave" {...register('leave_type')} /> Medical Half Day Leave
                                                            </label>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                                <input type="radio" value="Regular S.L Time" {...register('leave_type')} /> Regular S.L Time
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                                <input type="radio" value="Medical S.L Time" {...register('leave_type')} /> Medical S.L Time
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="text-sm text-danger">
                                            {errors.leave_type && <p>{errors.leave_type.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">From Date <span className="text-danger">*</span></label>
                                        <input className="form-control" type="date" {...register('from_date')} id="from_date" onChange={(e) => checkNumberOfDays(e.target.value, document.getElementById('to_date').value)}/>
                                        <div className="text-sm text-danger">
                                            {errors.from_date && <p>{errors.from_date.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">To Date <span className="text-danger">*</span></label>
                                        <input className="form-control" type="date" {...register('to_date')} id="to_date" onChange={(e) => checkNumberOfDays(document.getElementById('from_date').value, e.target.value)}/>
                                        <div className="text-sm text-danger">
                                            {errors.to_date && <p>{errors.to_date.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">No. of Days</label>
                                        <input type="text" className='form-control' value={days.toString() === 'NaN' ? 0 : days} readOnly />
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">From Time <span className="text-danger">*</span></label>
                                        <input className="form-control" type="time" {...register('from_time')} id="from_time" onChange={(e) => calculateTimeDiff(e.target.value, document.getElementById('to_time').value)}/>
                                        <div className="text-sm text-danger">
                                            {errors.from_time && <p>{errors.from_time.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">To Time <span className="text-danger">*</span></label>
                                        <input className="form-control" type="time" {...register('to_time')} id="to_time" onChange={(e) => calculateTimeDiff(document.getElementById('from_time').value, e.target.value)}/>
                                        <div className="text-sm text-danger">
                                            {errors.to_time && <p>{errors.to_time.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Total Time</label>
                                        <input type="text" className='form-control' value={time.toString() === 'NaN:NaN' ? '' : time} readOnly />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Requested to Manager/TeamLead<span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('requested_to')}>
                                            <option value="">Select Manager/TeamLead</option>
                                            {teamLead.map(tl => (
                                                <option key={tl.id} value={tl.id}>{tl.name} ({tl.designation})</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.requested_to && <p>{errors.requested_to.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Reason <span className="text-danger">*</span></label>
                                        <textarea className="form-control" type="text" {...register('reason')}></textarea>
                                        <div className="text-sm text-danger">
                                            {errors.reason && <p>{errors.reason.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddLeave